import type { CalculatorEquation } from "../../types/generated/api/CalculatorEquation"

export const reorderList = (list: CalculatorEquation[], index: number, direction: string): CalculatorEquation[] => {
  // Create a new list
  const newList = [...list]
  // Check if the direction is "up"
  if (direction === "up" && index > 0) {
    // Remove the object at the specified index and insert it at the previous index
    newList.splice(index - 1, 0, newList.splice(index, 1)[0] as CalculatorEquation)
  }

  // Check if the direction is "down"
  else if (direction === "down" && index < newList.length - 1) {
    // Remove the object at the specified index and insert it at the next index
    newList.splice(index + 1, 0, newList.splice(index, 1)[0] as CalculatorEquation)
  }

  return newList
}
